(function() {
	function init() {
		const cartContainer = document.querySelector('.cart, #mini-cart, cart-drawer');
		if (!cartContainer) {
			return;
		}
		
		cartContainer.addEventListener('click', function(e) {
			const toggleButton = e.target.closest('.show-bundle-items-button');
			if (!toggleButton) {
				return;
			}
			
			e.preventDefault();
			e.stopPropagation();
			
			const cartBundleContainer = toggleButton.closest('.cart-bundle-items');
			if (!cartBundleContainer) {
				return;
			}
			
			const itemComponents = cartBundleContainer.querySelector('.bundle-items-components');
			if (!itemComponents) {
				return;
			}
			
			const toggleIcon = toggleButton.querySelector('.cart-bundle-toggle-icon');
			const buttonText = toggleButton.querySelector('.cart-bundle-button-text');
			
			const isHidden = itemComponents.classList.toggle('hidden-bundle-items');
			
			if (toggleIcon) {
				toggleIcon.classList.toggle('rotate-svg', !isHidden);
			}
			
			if (buttonText && itemComponents.dataset) {
				buttonText.textContent = isHidden
					? (itemComponents.dataset.showItems || 'Show items')
					: (itemComponents.dataset.hideItems || 'Hide items');
			}
		});
	}
	
		document.addEventListener('DOMContentLoaded', init);
})();



